import { jsx } from 'panel';
import { ChartTooltipEl } from 'common/components/chart-tooltip';
export function template() {
  const {
    tooltip
  } = this.state;
  const isCompact = this.attr("is-compact");
  const {
    segments
  } = this.attr("params");
  const showTimeComparison = segments.some(segment => "timeComparisonValue" in segment);
  return jsx("div", {
    sel: '.bar-chart'
  }, !isCompact || showTimeComparison ? jsx("div", {
    sel: '.legend',
    class: {
      'show-time-comparison-compact': isCompact && showTimeComparison
    }
  }, segments.map(segment => jsx("div", {
    sel: '.bar-segment'
  }, jsx("div", {
    sel: '.segment-name',
    attrs: {
      title: segment.label
    }
  }, segment.label)))) : null, jsx("div", {
    sel: '.segments',
    class: {
      'is-compact': isCompact
    }
  }, segments.map((segment, idx) => {
    const segmentColor = this.helpers.getSegmentColor(idx);
    return jsx("div", {
      sel: '.segment',
      class: {
        'show-time-comparison': showTimeComparison
      }
    }, isCompact && !showTimeComparison ? jsx("div", {
      sel: '.bar-label-compact'
    }, jsx("div", {
      sel: '.segment-name',
      attrs: {
        title: segment.label
      }
    }, segment.label)) : null, jsx("div", {
      sel: '.segment-data',
      on: {
        mouseenter: ev => this.helpers.mousedOverSegment(ev, segment, segmentColor),
        mousemove: ev => this.helpers.mousedOverSegment(ev, segment, segmentColor),
        mouseleave: this.helpers.onMouseLeave
      }
    }, showTimeComparison ? jsx("div", {
      sel: '.comparison-bar',
      style: this.helpers.getTimeComparisonStyle(segmentColor, segment.timeComparisonBarWidth)
    }, jsx("div", {
      sel: '.bar-label.bar-label-outside'
    }, jsx("div", {
      sel: '.bar-label-amount',
      attrs: {
        title: this.helpers.getPrettifiedCount(segment.timeComparisonValue)
      }
    }, "".concat(segment.timeComparisonVisibleAmount, " \u2022")), jsx("div", {
      sel: '.bar-label-percentage'
    }, this.helpers.formatPercent(segment.timeComparisonPercentage / 100, 1)))) : null, jsx("div", {
      sel: '.bar',
      style: {
        'background-color': segmentColor,
        width: "".concat(Math.abs(segment.barWidth), "%")
      }
    }, (() => {
      const useInsideLabel = !showTimeComparison && Math.abs(segment.barWidth) > 40;
      return jsx("div", {
        sel: '.bar-label',
        class: {
          ["bar-label-".concat(useInsideLabel ? "inside" : "outside")]: true
        },
        style: {
          color: useInsideLabel ? this.helpers.getInsideTextColor(idx) : null
        }
      }, jsx("div", {
        sel: '.bar-label-amount',
        attrs: {
          title: this.helpers.getPrettifiedCount(segment.value)
        }
      }, "".concat(segment.visibleAmount, " \u2022")), jsx("div", {
        sel: '.bar-label-percentage'
      }, this.helpers.formatPercent(segment.percentage / 100, 1)));
    })()), tooltip.sections && tooltip.label === segment.label ? jsx(ChartTooltipEl, {
      attrs: {
        'title-color': showTimeComparison ? null : segmentColor,
        sections: tooltip.sections
      },
      style: tooltip.style
    }) : null));
  })));
}